import * as React from "react";
import type { SVGProps } from "react";

interface MainProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Main = ({ cancelled = false, ...props }: MainProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={66}
    viewBox="0 0 66 66"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#FFF"
        strokeWidth={6}
        d="M7 27.343c0-4.694 9.849-8.4 25.004-8.136 14.415.252 25.776 3.359 25.993 8.797L58 41.015a1 1 0 0 1-.22.623q-6.236 7.775-25.28 7.775c-19.39 0-25.5-7.301-25.5-7.562v-1.449l.001-.156V38.93l.001-.22v-1.218l.001-.268v-1.15l.001-.307v-.97l.001-.34v-1.065l.001-.37V31.86l.001-.403v-.83l.001-.426v-.878l.001-.45v-1.285A3 3 0 0 1 7 27.343Zm15.552 7.983.389.064q3.85.612 8.388.612 1.287 0 2.533-.046-.746.01-1.505.01c-3.528 0-6.828-.228-9.805-.64Z"
      />
      <g stroke="#000" strokeWidth={2}>
        <path
          fill="#6F6F6F"
          d="M6 29.05c4.562 4.02 13.026 5.952 25.329 5.952 11.964 0 21.193-1.877 27.671-5.693v11.708a2 2 0 0 1-.44 1.247c-4.287 5.342-12.912 8.149-26.06 8.149-6.733 0-11.893-.87-15.77-2.02-2.652-.786-4.712-1.705-6.27-2.575a20 20 0 0 1-2.563-1.682C6.283 42.87 6 41.949 6 41.85Z"
        />
        <path
          fill="#BDBDBD"
          strokeLinejoin="round"
          d="M13.844 20.353c4.418-1.438 10.655-2.277 18.177-2.146 7.71.135 14.558 1.084 19.35 2.748 2.395.831 4.29 1.85 5.57 3.016 1.387 1.261 2.086 2.703 2.058 4.28-.024 1.397-.764 2.716-2.248 3.867-1.309 1.017-3.222 1.914-5.635 2.642-4.655 1.404-11.221 2.206-18.76 2.206-7.341 0-13.713-.98-18.29-2.536-2.48-.844-4.447-1.864-5.791-2.981C6.749 30.18 6 28.77 6 27.343c0-1.455.721-2.864 2.205-4.117 1.296-1.094 3.198-2.078 5.639-2.873Z"
        />
      </g>
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Main;
